import pako from 'pako';


export const decompressData = (encodedData: string): string => {
    // Decode Base64 to a binary string
    const binaryString = atob(encodedData);
    // Convert binary string to Uint8Array
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    // Decompress using pako
    return pako.inflate(bytes, { to: 'string' });
};